/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UtenteListItemDto } from '../../models/utente-list-item-dto';

export interface ApiAuthUtenteCorpoListGet$Params {
    /**
     * Id del corpo per cui caricare gli utenti, valido solo nel caso l'utente abbia un ruolo superiore al corpo
     */
    corpoId?: number;
}

export function apiAuthUtenteCorpoListGet(
    http: HttpClient,
    rootUrl: string,
    params?: ApiAuthUtenteCorpoListGet$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<Array<UtenteListItemDto>>> {
    const rb = new RequestBuilder(rootUrl, apiAuthUtenteCorpoListGet.PATH, 'get');
    if (params) {
        rb.query('corpoId', params.corpoId, {});
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<Array<UtenteListItemDto>>;
        }),
    );
}

apiAuthUtenteCorpoListGet.PATH = '/api/auth/utente-corpo-list';
